import type { Id, OrderListItem } from "../../types";
import OrderCard from "./OrderCard";

interface OrdersGridProps {
  orders: OrderListItem[];
  selectedOrderId: Id | null;
  orderDetailsLoading: boolean;
  className: string;
  onShowDetails: (order: OrderListItem) => void;
  resolveOrderDetailId: (order: OrderListItem) => Id | null;
  getOrderKey: (order: OrderListItem) => string;
  formatOrderLabel: (order: OrderListItem) => string;
  formatDateTime: (value?: string) => string;
  formatDate: (value?: string) => string;
  formatCurrency: (value?: number | null) => string;
  getOrderStatusLabel: (order: OrderListItem) => string;
  ariaLive?: "polite" | "assertive" | "off";
}

const OrdersGrid = ({
  orders,
  selectedOrderId,
  orderDetailsLoading,
  className,
  onShowDetails,
  resolveOrderDetailId,
  getOrderKey,
  formatOrderLabel,
  formatDateTime,
  formatDate,
  formatCurrency,
  getOrderStatusLabel,
  ariaLive = "polite",
}: OrdersGridProps) => (
  <div className={className} role="region" aria-live={ariaLive}>
    {orders.map((order) => {
      const detailId = resolveOrderDetailId(order);
      const isActive = detailId != null && detailId === selectedOrderId;
      const isLoadingDetails =
        orderDetailsLoading && detailId === selectedOrderId;
      return (
        <OrderCard
          key={getOrderKey(order)}
          order={order}
          isActive={isActive}
          isLoading={isLoadingDetails}
          onShowDetails={onShowDetails}
          formatOrderLabel={formatOrderLabel}
          formatDateTime={formatDateTime}
          formatDate={formatDate}
          formatCurrency={formatCurrency}
          getOrderStatusLabel={getOrderStatusLabel}
        />
      );
    })}
  </div>
);

export default OrdersGrid;
